// local fork of react-schedule-selector
import ScheduleSelector from './ScheduleSelector'

export default ScheduleSelector
